var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"body"}},[(_vm.isOpen)?_c('div',{staticClass:"fixed top-0 left-0 right-0 bottom-0",class:_vm.size === 'full' ? '' : 'flex items-center justify-center',style:({ zIndex: _vm.zIndex }),attrs:{"data-testid":"modal-overlay"},on:{"mousedown":_vm.handleOverlayMouseDown,"click":_vm.handleOverlayClick}},[_c('div',{staticClass:"fixed top-0 left-0 right-0 bottom-0 bg-black opacity-75",style:({ zIndex: -1 })}),_c('div',{class:[
        'bg-white',
        _vm.size !== 'custom' ? _vm.sizeStyles[_vm.size] : '',
        _vm.size === 'full'
          ? 'm-0 w-full h-full rounded-none flex flex-col'
          : 'm-4 w-full flex flex-col',
        _vm.className
      ],style:(_vm.modalInlineStyles),attrs:{"data-testid":"modal-container","role":"dialog","aria-modal":"true"}},[_c('div',{class:[
          _vm.size === 'full' ? 'flex-1 overflow-y-scroll' : '',
          _vm.bodyClassName
        ],style:(_vm.bodyInlineStyles),attrs:{"data-testid":"modal-body"}},[_vm._t("default")],2)])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }